// @flow
import React, { useState, useMemo, useEffect } from 'react';
import {FormattedMessage} from 'react-intl';
import Button from '@material-ui/core/Button';
import List from "@material-ui/core/List";
import Box from "@material-ui/core/Box";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import ListIcon from '@material-ui/icons/List';
import AddIcon from '@material-ui/icons/Add';
import type {Zone} from '../../types';
import { defaultPadding } from '../../services/map';
import { useSidebarWidth } from '../Sidebar/context';
import Header from '../Sidebar/Header';
import NewZoneForm from '../ZoneForm';
import ZoneList from './ZoneList';
import ZoneTypeSelector from './ZoneTypeSelector';

export type Props = $ReadOnly<{
    lists: $ReadOnly<{
        permanent: $ReadOnlyArray<$PropertyType<Zone, 'id'>>,
        temporary: $ReadOnlyArray<$PropertyType<Zone, 'id'>>
    }>,
    drawingEnabled: boolean,
    drawingZone?: Zone,

    enableDrawing: () => void,
    disableDrawing: () => void
}>;

function Zones({lists, drawingEnabled, drawingZone, enableDrawing, disableDrawing}: Props) {
    const [type, setType] = useState('permanent');
    const [formInitialized, setFormInitialized] = useState();
    const sidebarWidth = useSidebarWidth();
    const locatePadding = useMemo(() => [defaultPadding, defaultPadding, defaultPadding, defaultPadding + sidebarWidth], [sidebarWidth]);

    useEffect(() => {
        if(drawingEnabled) {
            setTimeout(() => setFormInitialized(true));
        }

        return () => {
            setFormInitialized(false);
        };
    }, [drawingEnabled, drawingZone]);

    useEffect(() => {
        return () => {
            disableDrawing();
        };
    }, [disableDrawing]);

    const handleEnableDrawing = () => enableDrawing();
    const handleDisableDrawing = () => disableDrawing();

    return (
        <List subheader={(
            <Header
                title={(
                    <Box fontSize="h6.fontSize">
                        <FormattedMessage
                            id="sidebar.zones.header"
                            defaultMessage="Zones"
                        />
                    </Box>
                )}
            />
        )}>
            <ZoneTypeSelector type={type} onChange={setType}/>
            <BottomNavigation value={ drawingEnabled && formInitialized ? 'add' : 'list'} showLabels={true}>
                <BottomNavigationAction value="list" label="All Zones" icon={<ListIcon />} onClick={handleDisableDrawing} />
                <BottomNavigationAction value="add" label="Add Zone" icon={<AddIcon />} onClick={handleEnableDrawing} />
            </BottomNavigation>
            <Box px={2}>
                {!drawingEnabled &&
                    <React.Fragment>
                        {type === 'permanent' &&
                            <ZoneList list={lists.permanent} locatePadding={locatePadding}/>
                        }
                        {type === 'temporary' &&
                            <ZoneList list={lists.temporary} locatePadding={locatePadding}/>
                        }
                        {/*<Button color="primary" variant="contained" fullWidth onClick={handleEnableDrawing}>*/}
                        {/*    <FormattedMessage*/}
                        {/*        id="sidebar.zones.createZoneButton"*/}
                        {/*        defaultMessage="Create zone"*/}
                        {/*    />*/}
                        {/*</Button>*/}
                    </React.Fragment>
                }
                {drawingEnabled && formInitialized && <Box pt={1}><NewZoneForm type={type} zone={drawingZone}/></Box>}
            </Box>
        </List>
    );
}

export default Zones;